import { doSignoutTask } from '../user/doSignoutTask';
import { supbaseSignOut } from '../supabase/supbaseSignOut';

const userAuthFailed = async () => {
  supbaseSignOut();
  doSignoutTask();
};

export { userAuthFailed };
